import { isSimpleRecurrence, recurrenceIntervalString } from '@frontend/api-client';
import type { Recurrence, SimpleRecurrence } from '@frontend/api-types';
import { dayjs } from '@frontend/duck-tape';
import { CardBadge, CardContent, CardHeader, XStack, YStack } from '@frontend/web-react';
import { NavLinkWrapper } from '@frontend/web/components';
import { appendRouteHistoryStack } from '@frontend/web/router';

type ScheduledTaskCardProps = {
  recurrence: Recurrence | SimpleRecurrence;
};

export const ScheduledTaskCard = ({ recurrence }: ScheduledTaskCardProps) => {
  const simple = isSimpleRecurrence(recurrence);
  const title = simple ? recurrence.taskName : recurrence.name;
  const nextDate = simple ? recurrence.nextTriggerAt : recurrence.nextTaskDueDate;

  return (
    <NavLinkWrapper
      className="flex-col p-md hover-background-effect"
      state={{ routeHistoryStack: appendRouteHistoryStack('/app') }}
      to={`/app/recurrence/${recurrence.id}`}
    >
      <YStack className="gap-lg">
        <YStack className="gap-sm">
          <CardHeader title={title} />
          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
          {/* @ts-expect-error */}
          <CardContent description={recurrence.description} descriptionTextProps={{ lineClamp: 2 }} />
        </YStack>
        <XStack className="gap-sm">
          {nextDate ? (
            <CardBadge
              containerClassName="bg-violet-100"
              iconColor="violet"
              leftIconName="IconCalendar"
              size="md"
              text={`Next: ${dayjs(nextDate).format('M/D')}`}
              textClassName="text-violet-900"
            />
          ) : null}
          {!simple ? (
            <CardBadge
              containerClassName="bg-neutral-100"
              iconColor="neutral"
              leftIconName="IconRepeat"
              size="md"
              text={recurrenceIntervalString(recurrence)}
              textClassName="text-neutral-900"
            />
          ) : null}
        </XStack>
      </YStack>
    </NavLinkWrapper>
  );
};
